import React, { FunctionComponent } from 'react';
import MeetingPointIcon from '../icons/MeetingPointIcon';
import Typography from '../typography/Typography';
import './meetingPoint.scss';

type MeetingPointProps = {
  meetingPoint: string,
  className: string,
  text?: string
}

const MeetingPoint: FunctionComponent<MeetingPointProps> = ({
  meetingPoint,
  className = '',
  text = 'Meeting point',
}) => (
  <div className={`meeting-point d-flex p-t-12 p-b-12 p-r-16 border-radius-8 flex-direction-column ${className}`}>
    <div className="d-flex align-items-center m-b-8">
      <span className="p-l-17 p-r-17 d-flex align-items-center">
        <MeetingPointIcon width={24} color="blue5" />
      </span>
      <Typography
        variant="subtitle1"
        color="dark"
      >
        { text }
      </Typography>
    </div>

    <Typography
      variant="body1"
      color="dark"
      className="p-l-56"
    >
      {meetingPoint}
    </Typography>
  </div>
);

export default MeetingPoint;
